// test1055
(1055 && 0);
